<!-- 跳转到积分商城的空页面 -->
<template>
  <div class='store-container'>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Config from '@/config/config'

export default {
  name: 'Store',
  data() {
    return {
    }
  },

  mounted() {
  },
  created() {
    if (this.userInfo.id) {
      const storeUrl = Config.creditStoreBaseUrl + '/?name=' + this.userInfo.nickname + '&gender=' + this.userInfo.gender +
      '&province=' + this.userInfo.province + '&city=' + this.userInfo.city + '&avatar=' + this.userInfo.avatar +
       '&userCode=' + this.userInfo.openid + '&appId=' + Config.creditStoreAppId + '&phone=' + this.userInfo.mobile
      window.location.href = storeUrl
    }
  },

  computed: {
    ...mapGetters(['userInfo'])
  },

  watch: {
    userInfo() {
      if (this.userInfo.id) {
        const storeUrl = Config.creditStoreBaseUrl + '/?name=' + this.userInfo.nickname + '&gender=' + this.userInfo.gender +
        '&province=' + this.userInfo.province + '&city=' + this.userInfo.city + '&avatar=' + this.userInfo.avatar +
        '&userCode=' + this.userInfo.openid + '&appId=' + Config.creditStoreAppId + '&phone=' + this.userInfo.mobile
        window.location.href = storeUrl
      }
    }
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/store.vue